import { useFormContext, useWatch } from 'react-hook-form';

import Icon from 'components/global/Icon';
import Tooltip from 'components/global/Tooltip';
import Typography from 'components/global/Typography';

import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCircleNotch } from '@fortawesome/pro-solid-svg-icons';

const PriceColumn = ({ index }) => {
	const formMethods = useFormContext();
	const {
		control,
		formState: { errors }
	} = formMethods;

	const watchedItem = useWatch({
		control,
		name: `items[${index}]`
	});

	const price = watchedItem.price;
	const priceLoading = watchedItem.priceLoading;
	const isPriceNull = price === null;
	const isRequired = errors?.items?.[index]?.price?.type === 'required';

	return priceLoading ? (
		<div
			style={{
				overflow: 'hidden'
			}}>
			<Icon icon={faCircleNotch} className="fa-spin" color="var(--blue)" />
		</div>
	) : price ? (
		<Typography fontWeight="500" withCurrency>
			{price}
		</Typography>
	) : isPriceNull ? (
		<Tooltip title="errorMessageOrderCannotCreateShipment">
			<Icon icon={faExclamationCircle} color="var(--red)" size="large" />
		</Tooltip>
	) : isRequired ? (
		<Tooltip title="alert.requiredField">
			<Icon icon={faExclamationCircle} color="var(--red)" size="large" />
		</Tooltip>
	) : (
		<></>
	);
};

export default PriceColumn;
